import type { Message } from "ably";
import { PushType } from "@/enums/push";

export function GetNotification<T>(
  message: Message,
  type: PushType
): T | null {
  try {
    if (message.name === type && message.data) {
      return message.data as T;
    }
  } catch (e) {
    console.error(e);
  }
  return null;
}
